import * as ActionTypes from './types.action';

export const resetNextRoute = () => ({
  type: ActionTypes.NAVIGATE_RESET,
});
